export const addStylesLink = (documentEl: Document, href: string) => {
    const newLinkEl = documentEl.createElement('link');

    newLinkEl.rel = 'stylesheet';
    newLinkEl.href = href;
    documentEl.head.appendChild(newLinkEl);
};
